import React from 'react'
import Layout from '../Layout/Layout';

import "./admininventory.scss";
import TopMenu from "~/Admin/Layout/TopMenu/TopMenu";
import { NavLink, Route } from "react-router-dom";

import AdminInventoryManagement from "./AdminInventoryManagement/AdminInventoryManagement";
import AdminWaveManagement from "./AdminWaveManagement/AdminWaveManagement";
import AdminPackageManagement from "./AdminPackageManagement/AdminPackageManagement";
import { connect } from "react-redux";

const AdminInventory = ({ match, ...props }) => {

    return (
        <Layout>

            <h1>Inventory Management</h1>

            <TopMenu>
                <NavLink
                    activeClassName="active"
                    exact
                    to={`${match.path}`}>
                    Inventory
                </NavLink>
                <NavLink
                    activeClassName="active"
                    exact
                    to={`${match.path}/wave`}>
                    Wave Management
                </NavLink>
                <NavLink
                    activeClassName="active"
                    exact
                    to={`${match.path}/package`}>
                    Package Management
                </NavLink>
            </TopMenu>

            <div className="content mt-5">
                <Route exact path={`${match.path}`} component={AdminInventoryManagement} />
                <Route exact path={`${match.path}/wave`} component={AdminWaveManagement} />
                <Route exact path={`${match.path}/package`} component={AdminPackageManagement} />
            </div>

        </Layout>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminInventory);
